module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', {
    staticClass: "moduleWrapper"
  }, [_c('md-card-content', {
    staticClass: "module moduleOne"
  }, [_c('md-card', {
    staticClass: "card",
    class: {
      dark: _vm.slides[_vm.slidePosition].isDark, layoutTwo: _vm.slides[_vm.slidePosition].layout2, layoutThree: _vm.slides[_vm.slidePosition].layout3, layoutFour: _vm.slides[_vm.slidePosition].layout4, listLeft: _vm.slides[_vm.slidePosition].listLeft, tourSlide: _vm.slides[_vm.slidePosition].tour || _vm.slides[_vm.slidePosition].device, tourQuiz: _vm.slides[_vm.slidePosition].tourQuiz, listsText: _vm.slides[_vm.slidePosition].listsText, elements: _vm.slides[_vm.slidePosition].elements, fin: _vm.slides[_vm.slidePosition].fin, quizSlide: _vm.slides[_vm.slidePosition].quiz
    },
    attrs: {
      "md-with-hover": ""
    }
  }, [_c('md-card-area', {
    attrs: {
      "md-inset": ""
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "slide-left"
    }
  }, [(_vm.slides[_vm.slidePosition].lines || _vm.slides[_vm.slidePosition].links) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "lineWrap"
  }, [_vm._l((_vm.slides[_vm.slidePosition].lines), function(line) {
    return _c('p', {
      class: {
        bold: line.b, orange: line.o
      }
    }, [_vm._v(_vm._s(line.text))])
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].links), function(link) {
    return _c('p', {
      class: {
        bold: link.b, orange: link.o
      },
      on: {
        "click": function($event) {
          _vm.jumpTo(link.jump)
        }
      }
    }, [_vm._v(_vm._s(link.a))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].img) ? _c('img', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "device",
    class: {
      charger: _vm.slides[_vm.slidePosition].charger
    },
    attrs: {
      "src": _vm.slides[_vm.slidePosition].img,
      "alt": "Body Guard"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].modal) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "wrap"
  }, [_c('img', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "device",
    attrs: {
      "src": _vm.slides[_vm.slidePosition].modalImg,
      "alt": "Body Guard"
    }
  }), _vm._v(" "), (_vm.slides[_vm.slidePosition].modal) ? _c('md-button', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "md-primary md-raised modal",
    attrs: {
      "id": "modal"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('pop')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.slides[_vm.slidePosition].modalIcon,
      "alt": "Features"
    }
  }), _vm._v("Full list of features")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].modal) ? _c('md-dialog', {
    key: _vm.slides[_vm.slidePosition].id,
    ref: "pop",
    attrs: {
      "md-open-from": "#modal",
      "md-close-to": "#modal"
    }
  }, [_c('md-dialog-content', [_c('div', {
    staticClass: "inner"
  }, [_c('md-button', {
    staticClass: "md-primary close",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('pop')
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("The BodyGuard 323 Color Vision™ system is intended for patients who require maintenance medication, analgesics, PCA therapy, parenteral, chemotherapeutic agents, and general fluids therapy in hospital and home care environments. ")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("The BodyGuard 323 Color Vision™ infusion pump system is designed for infusion of medications or fluids requiring continuous or intermittent delivery at precisely-controlled infusion rates through clinically acceptable routes of administration, including intravenous, subcutaneous, percutaneous, intra-arterial, epidural, in close proximity to nerves, and into an intraoperative site (soft tissue/body cavity/surgical wound site).")]), _vm._v(" "), _c('p', {
    staticClass: "orange bold"
  }, [_vm._v("The BodyGuard 323 Color Vision™ system provides the following features:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Small, light and compact pump ideal for ambulatory use both in hospital and homecare environment.")]), _vm._v(" "), _c('li', [_vm._v("Highly accurate fluid delivery operated with a custom safe administration set")]), _vm._v(" "), _c('li', [_vm._v("Rechargeable internal lithium-Polymer battery or alkaline 2X9V batteries")]), _vm._v(" "), _c('li', [_vm._v("Battery charged in a pole mount charging cradle or with an A/C adaptor")]), _vm._v(" "), _c('li', [_vm._v("Quiet operation")]), _vm._v(" "), _c('li', [_vm._v("Used for ambulatory care in a carrying pouch or mounted on an IV pole")]), _vm._v(" "), _c('li', [_vm._v("AEA – Suitable to be used in ambulances")]), _vm._v(" "), _c('li', [_vm._v("Access to events log and history functions")])]), _vm._v(" "), _c('p', {
    staticClass: "orange bold"
  }, [_vm._v("Safety features: ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Free flow protection valve standard on every CME administration set")]), _vm._v(" "), _c('li', [_vm._v("Air-in-line accumulation system in addition to the standard single bubble detection")]), _vm._v(" "), _c('li', [_vm._v("The anti-bolus function designed to reduce the bolus that may occur upon the release of an occlusion following a downstream occlusion alarm.")])]), _vm._v(" "), _c('p', {
    staticClass: "orange bold"
  }, [_vm._v("Multiple Programs makes it adaptable to different clinical applications:")]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("1.Continous")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Infusion Rate: 0.1 to 1200 ml/hr")]), _vm._v(" "), _c('li', [_vm._v("Volume: 0.1 to 99.9 ml in 0.1ml increments or 1 to 9999 ml in 1ml increments")]), _vm._v(" "), _c('li', [_vm._v("Secondary Infusion programmable and Bolus programmable")])]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("2. PCA")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Patient Control Analgesia: Continuous delivery plus /or programmed boluses.")]), _vm._v(" "), _c('li', [_vm._v("Bolus Volume: 0-25.5 ml")]), _vm._v(" "), _c('li', [_vm._v("Clinician Bolus Volume: 0.1-100ml")]), _vm._v(" "), _c('li', [_vm._v("Bolus Rate: 0.1-1200 ml/h")])]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("3. TPN")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Total Parenteral Nutrition Rate Taper program with programmable up and down times.")])]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("4. Intermittent")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("A set dose delivered in set intervals. Between Intervals the pump will keep vain open (KVO Mode).")])]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("5. 25 Steps")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Operator can design a specific protocol for drug delivery which contains up to 25 steps.")]), _vm._v(" "), _c('li', [_vm._v("Infusion Rate: 0.1 to 1200 ml/hr")]), _vm._v(" "), _c('li', [_vm._v("Volume: up to 9999ml, for each step")]), _vm._v(" "), _c('li', [_vm._v("Accumulated Volume for all steps – up to 10 liters, or in volume over time mode.")])]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v("6. Drug Library")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Continuous program, as above, comprises 128 drug protocols based on patient data. Protocols have hard and soft limits for added patient safety.")]), _vm._v(" "), _c('li', [_vm._v("Please always refer to the DFU (direction for use) in case of any doubt.")])])], 1)])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].lists) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "listWrap"
  }, [_vm._l((_vm.slides[_vm.slidePosition].lists), function(list) {
    return _c('ul', [(list.title) ? _c('li', {
      staticClass: "listTitle",
      class: {
        bold: list.b, orange: list.o
      }
    }, [_vm._v(_vm._s(list.title))]) : _vm._e(), _vm._v(" "), _vm._l((list.items), function(item) {
      return _c('li', {
        staticClass: "listItem",
        class: {
          bold: list.b, orange: list.o
        }
      }, [_vm._v(_vm._s(item.text))])
    })], 2)
  }), _vm._v(" "), (_vm.slides[_vm.slidePosition].linkHref) ? _c('a', {
    key: _vm.slides[_vm.slidePosition].id,
    attrs: {
      "href": _vm.slides[_vm.slidePosition].linkHref,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].linkText))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].els), function(el) {
    return (_vm.slides[_vm.slidePosition].els) ? _c('div', {
      key: _vm.slides[_vm.slidePosition].id,
      staticClass: "els"
    }, [_c('div', {
      staticClass: "wrap"
    }, [_c('img', {
      attrs: {
        "src": el.img,
        "alt": "Body Guard"
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(el.t))])]) : _vm._e()
  }), _vm._v(" "), (_vm.slides[_vm.slidePosition].img2) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "shiftWrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.slides[_vm.slidePosition].img2,
      "alt": "Body Guard"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].tourQuiz) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "tourQuizText"
  }, [_c('p', {
    key: _vm.slides[_vm.slidePosition].id
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].text))]), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (_vm.slides[_vm.slidePosition].tourQuiz) ? _c('h4', [_vm._v(_vm._s(tip.question))]) : _vm._e()
  }), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tick.png"),
      "alt": ""
    }
  }), _vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct === false) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "alt": ""
    }
  }), _vm._v("Incorrect")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.img) ? _c('img', {
      key: _vm.slides[_vm.slidePosition].id,
      staticClass: "device-tip",
      class: {
        current: tip.current
      },
      attrs: {
        "src": tip.img,
        "alt": "Body Guard"
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('ul', {
      key: _vm.slides[_vm.slidePosition].id,
      staticClass: "tooltips",
      class: {
        current: tip.current
      }
    }, [_c('li', {
      staticClass: "tipTitle",
      class: {
        bold: tip.b, orange: tip.o
      }
    }, [_vm._v(_vm._s(tip.title))]), _vm._v(" "), _vm._l((tip.items), function(item) {
      return _c('li', {
        staticClass: "tipItem",
        class: {
          bold: item.b, orange: item.o
        }
      }, [_vm._v(_vm._s(item.text))])
    }), _vm._v(" "), (tip.lists) ? _c('ul', {
      staticClass: "tipList"
    }, _vm._l((tip.lists), function(list) {
      return _c('li', [_vm._v(_vm._s(list.text))])
    })) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "glow"
  }, [_vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.bar) ? _c('div', {
      staticClass: "glowButton",
      class: {
        bar: tip.bar, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.stopButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        stopButton: tip.stopButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.startButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        startButton: tip.startButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.primeButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        primeButton: tip.primeButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.powerButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        powerButton: tip.powerButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.lockButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        lock: tip.lockButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.infoButton) ? _c('div', {
      staticClass: "glowButton",
      class: {
        infoButton: tip.infoButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.numbers) ? _c('div', {
      staticClass: "glowButton",
      class: {
        numbers: tip.numbers, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.arrows) ? _c('div', {
      staticClass: "glowButton",
      class: {
        arrows: tip.arrows, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return (tip.LED) ? _c('div', {
      staticClass: "glowButton",
      class: {
        LED: tip.LED, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        display: tip.displayButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        release: tip.releaseButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        charger: tip.chargerButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        pump: tip.pumpButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        open1: tip.open1, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        open2: tip.open2, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        open3: tip.open3, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        open4: tip.open4, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        open5: tip.open5, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        open6: tip.open6, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        open7: tip.open7, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        open8: tip.open8, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        open9: tip.open9, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.nextTip(tip, _vm.slides[_vm.slidePosition].tooltips)
        }
      }
    })], 1)
  })], 2), _vm._v(" "), (_vm.slides[_vm.slidePosition].tourQuiz) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "tourQuiz"
  }, [_vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        bar: tip.bar, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('bar')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        stopButton: tip.stopButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('stop')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        startButton: tip.startButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('start')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        primeButton: tip.primeButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('prime')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        powerButton: tip.powerButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('power')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        lock: tip.lockButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('lock')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        infoButton: tip.infoButton, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('info')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        numbers: tip.numbers, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('numbers')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        arrows: tip.arrows, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('arrows')
        }
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.slides[_vm.slidePosition].tooltips), function(tip) {
    return _c('div', {
      staticClass: "glowButton",
      class: {
        LED: tip.LED, current: tip.current, noButton: _vm.noButton
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.buttonPressed('LED')
        }
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].video) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "video"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "height": "0",
      "padding-bottom": "75.0%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "left": "0"
    },
    attrs: {
      "src": _vm.slides[_vm.slidePosition].video,
      "width": "480",
      "height": "360",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].button) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.incrementPosition($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].button) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].quiz) ? _c('div', {
    key: _vm.slides[_vm.slidePosition].id,
    staticClass: "quiz"
  }, [_c('h4', [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].question))]), _vm._v(" "), (_vm.slides[_vm.slidePosition].multiAnswer) ? _c('div', [(_vm.slides[_vm.slidePosition].answers[0]) ? _c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "answer1",
      "value": "right"
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[0].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[1]) ? _c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "answer2",
      "value": "right"
    },
    model: {
      value: (_vm.answer2),
      callback: function($$v) {
        _vm.answer2 = $$v
      },
      expression: "answer2"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[1].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[2]) ? _c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "answer3",
      "value": "right"
    },
    model: {
      value: (_vm.answer3),
      callback: function($$v) {
        _vm.answer3 = $$v
      },
      expression: "answer3"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[2].text))]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.checkAnswer(3)
      }
    }
  }, [_vm._v("Check Answer")]), _vm._v(" "), (_vm.correct) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tick.png"),
      "alt": ""
    }
  }), _vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.incorrect) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "alt": ""
    }
  }), _vm._v("Incorrect")]) : _vm._e(), _vm._v(" "), (_vm.incorrect) ? _c('p', [_vm._v("The correct answer is all three")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].singleAnswerOne) ? _c('div', [(_vm.slides[_vm.slidePosition].answers[0]) ? _c('md-radio', {
    attrs: {
      "id": "answer1",
      "name": "group1",
      "md-value": "1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.answer(1)
      }
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[0].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[1]) ? _c('md-radio', {
    attrs: {
      "id": "answer2",
      "name": "group1",
      "md-value": "2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.answer(2)
      }
    },
    model: {
      value: (_vm.answer1),
      callback: function($$v) {
        _vm.answer1 = $$v
      },
      expression: "answer1"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[1].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tick.png"),
      "alt": ""
    }
  }), _vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].incorrect) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "alt": ""
    }
  }), _vm._v("Incorrect")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].incorrect) ? _c('p', [_vm._v("The correct answer is multiple programs to adapt to different clinical applications")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].singleAnswerTwo) ? _c('div', [(_vm.slides[_vm.slidePosition].answers[0]) ? _c('md-radio', {
    attrs: {
      "id": "answer1",
      "name": "group1",
      "md-value": "1"
    },
    nativeOn: {
      "click": function($event) {
        _vm.answer(1)
      }
    },
    model: {
      value: (_vm.answer2),
      callback: function($$v) {
        _vm.answer2 = $$v
      },
      expression: "answer2"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[0].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].answers[1]) ? _c('md-radio', {
    attrs: {
      "id": "answer2",
      "name": "group1",
      "md-value": "2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.answer(2)
      }
    },
    model: {
      value: (_vm.answer2),
      callback: function($$v) {
        _vm.answer2 = $$v
      },
      expression: "answer2"
    }
  }, [_vm._v(_vm._s(_vm.slides[_vm.slidePosition].answers[1].text))]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].correct) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tick.png"),
      "alt": ""
    }
  }), _vm._v("Correct")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].incorrect) ? _c('md-button', {
    staticClass: "md-accent md-raised"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "alt": ""
    }
  }), _vm._v("Incorrect")]) : _vm._e(), _vm._v(" "), (_vm.slides[_vm.slidePosition].incorrect) ? _c('p', [_vm._v("The correct answer is True")]) : _vm._e()], 1) : _vm._e()]) : _vm._e()], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "progress"
    }
  }, [_c('div', {
    staticClass: "slideWrap"
  }, [_c('md-progress', {
    attrs: {
      "md-progress": _vm.progressPercent
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "progText"
  }, [_vm._v("Progress "), _c('b', [_vm._v(_vm._s(Math.trunc(_vm.progressPercent)) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "progNav"
  }, [_c('router-link', {
    attrs: {
      "to": "/front"
    }
  }, [_c('img', {
    staticClass: "home",
    attrs: {
      "src": require("../assets/home.svg"),
      "alt": "Front Page"
    }
  })]), _vm._v(" "), (_vm.notFirstSlide) ? _c('div', [_c('div', {
    staticClass: "imgWrap next",
    class: {
      disabled: _vm.disableBtn, tourHide: _vm.tourStarting, quizDisable: _vm.quizDisable, moduleEnd: _vm.moduleEnd
    },
    on: {
      "click": function($event) {
        _vm.incrementPosition(_vm.slidePosition)
      }
    }
  }, [_c('p', [_vm._v("Next")]), _c('img', {
    attrs: {
      "src": require("../assets/arrow-right-thick.svg"),
      "alt": "Next"
    }
  })]), _vm._v(" "), (_vm.moduleEnd) ? _c('div', {
    staticClass: "imgWrap next"
  }, [_c('router-link', {
    attrs: {
      "to": "/module-2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.moduleComplete(1, 2)
      }
    }
  }, [_c('p', [_vm._v("Next")]), _c('img', {
    attrs: {
      "src": require("../assets/arrow-right-thick.svg"),
      "alt": "Next"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgWrap prev md-disabled",
    on: {
      "click": _vm.decrementPosition
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/arrow-left-thick.svg"),
      "alt": "Prev"
    }
  }), _c('p', [_vm._v("Prev")])])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3da3b2d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Module1.vue
// module id = 751
// module chunks = 0